/** Rol de usuario: psicólogo (notas clínicas E2E, etc.) */
export const PSYCHOLOGIST_ROLE_ID = 1

/** Longitud del PIN numérico para notas clínicas E2E */
export const CLINICAL_NOTES_PIN_LENGTH = 4

/** Versión del payload de envelopes en API. */
export const CLINICAL_NOTES_CRYPTO_SCHEMA_VERSION = 1

/** Parámetros KDF v1 (PBKDF2-HMAC-SHA256). */
export const CLINICAL_NOTES_CRYPTO_KDF_PARAMS_V1 = {
  version: 1,
  name: 'PBKDF2',
  hash: 'SHA-256',
  iterations: 210000
}

export const CLINICAL_NOTES_MASTER_KEY_LENGTH = 32

export const CLINICAL_NOTES_KDF_SALT_LENGTH = 16

export const CLINICAL_NOTES_AES_GCM_IV_LENGTH = 12

/** Código de recuperación: longitud fija; solo [A-Za-z0-9] al generar. */
export const CLINICAL_NOTES_RECOVERY_CODE_LENGTH = 8

/** Alfabeto para código de recuperación (sin símbolos especiales). */
export const CLINICAL_NOTES_RECOVERY_CODE_ALPHABET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

/** Clave localStorage única por perfil de navegador para master_key E2E de notas clínicas. */
export const CLINICAL_NOTES_MASTER_KEY_STORAGE_KEY = 'mimente_mk_v1'

/** Valor API para notas cifradas en cliente. */
export const CLINICAL_NOTES_ENCRYPTION_MODE_E2E = 'e2e'
